module.exports = __webpack_public_path__ + "img/alterarlogo-icon.8af6a3d4.svg";